import React from "react";
import InputContainer from "./InputContainer";
import CreatableSelect from "react-select/creatable";
import { Controller } from "react-hook-form";

const CreatableTags = React.forwardRef((props, ref) => {
  const [inputValue, setInputValue] = React.useState("");
  
  const {
    label,
    name,
    placeholder,
    error,
    size,
    noPadding,
    disabled,
    control,
    defaultValue,
    readOnly,
  } = props;

  return (
    <InputContainer
      {...props}
      noPadding={noPadding}
      size={size}
      label={label}
      error={error}
    >
      <Controller
        control={control}
        name={name}
        rules={props.rules}
        defaultValue={defaultValue || ""}
        render={(fieldProps) => {
          // Convert comma-separated string to array of option objects
          const stringValue = fieldProps.value || "";
          const optionsArray = stringValue
            .split(",")
            .map((s) => s.trim())
            .filter((s) => s !== "")
            .map((s) => ({ label: s, value: s }));

          return (
            <CreatableSelect
              isMulti
              isDisabled={disabled || readOnly}
              placeholder={placeholder || "Type and press enter..."}
              value={optionsArray}
              inputValue={inputValue}
              onInputChange={(val) => setInputValue(val)}
              onKeyDown={(event) => {
                if (!inputValue) return;
                
                // Convert to tag on Enter, Tab, or Comma
                if (event.key === "Enter" || event.key === "Tab" || event.key === ",") {
                  event.preventDefault();
                  
                  let menuArray = stringValue.split(",").map(s => s.trim()).filter(s => s !== "");
                  menuArray.push(inputValue.trim());
                  
                  const newStringValue = menuArray.join(", ");
                  fieldProps.onChange(newStringValue);
                  setInputValue("");
                }
              }}
              onChange={(newValue) => {
                // newValue is an array of option objects
                const newStringValue = (newValue || [])
                  .map((opt) => opt.value)
                  .join(", ");
                fieldProps.onChange(newStringValue);
              }}
              menuIsOpen={false} // Since it's just for tags, we don't need a dropdown menu
              components={{ DropdownIndicator: null }}
              styles={{
                multiValue: (base) => ({
                  ...base,
                  backgroundColor: "#e2e3e5", // Match the screenshot's grey background
                }),
                multiValueLabel: (base) => ({
                  ...base,
                  color: "#333",
                }),
              }}
            />
          );
        }}
      />
    </InputContainer>
  );
});

export default CreatableTags;
